if (process.env.REACT_APP_BRAND === 'acom') {
  require('./acom.css');
}

if (process.env.REACT_APP_BRAND === 'aemp') {
  require('./aemp.css');
}

if (process.env.REACT_APP_BRAND === 'prtl') {
  require('./prtl.css');
}

if (process.env.REACT_APP_BRAND === 'suba') {
  require('./suba.css');
}

if (process.env.REACT_APP_BRAND === 'shop') {
  require('./shop.css');
}

if (process.env.REACT_APP_BRAND === 'soub') {
  require('./soub.css');
}

if (!process.env.REACT_APP_BRAND) {
  require('./acom.css');
}
